<template>
    <div class="parametric-sidebar-flat">
        <div class="parametric-sidebar-flat__name">
            {{ flatData.name }}
        </div>

        <div class="parametric-sidebar-flat__props">
            <span v-if="flatData.area"
                  class="parametric-sidebar-flat__props-value">{{ flatData.area }} м²</span>
            <span v-if="flatData.floor"
                  class="parametric-sidebar-flat__props-value">{{ flatData.floor }} этаж</span>
            <span v-if="flatData.section"
                  class="parametric-sidebar-flat__props-value">{{ flatData.section }} секция</span>
            <span v-if="flatData.building"
                  class="parametric-sidebar-flat__props-value">{{ flatData.building }} корпус</span>
            <span v-if="flatData.completion"
                  class="parametric-sidebar-flat__props-value">{{ flatData.completion }}</span>
        </div>

        <div class="parametric-sidebar-flat__price">
            <template v-if="flatData.price">
                {{ flatData.price | format }} ₽
            </template>
            <template v-else>
                Цена по запросу
            </template>
        </div>

        <div class="parametric-sidebar-flat__action"
             @click="removeFlat(flatData.id)">
            <IconTrash />
        </div>
    </div>
</template>

<script>
import IconTrash from '@/components/Icons/Trash';
import {mapActions} from 'vuex';

/**
 * Компонент помещения в сайдбаре
 */
export default {
    name: 'ParametricSidebarFlat',

    components: {
        IconTrash
    },

    filters: {
        format: (val) => {
            return `${Math.floor(val)}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
        },

        clearLink: (url) => {
            // Удаляем "http://" или "https://" из начала строки
            url = url.replace(/^https?:\/\//i, '');

            // Удаляем завершающий символ "/", если он есть
            url = url.replace(/\/$/, '');

            return url;
        },
    },

    props: {
        flatData: Object // Данные помещения
    },
    
    methods: {
        ...mapActions('parametric', ['removeFlatFromPrint']),

        /**
         * Удаляет помещение из печати
         * @param {String} id - id удаляемого помещения
         */
        removeFlat(id) {
            this.removeFlatFromPrint(id);
        }
    }
};
</script>
